// extracted by mini-css-extract-plugin
module.exports = {"container":"SGK0h","text":"_2ook-","icon":"_3aH5k"};